module.exports = "//docs.gtimg.com/slide/img/framework/frame/components/animation-editor/images/toolbar_add_tool_modao-fea239.svg";